import React, { useEffect, useState } from "react"
import {
    Row,
    Col,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
} from "reactstrap"
import { AvForm, AvField } from 'availity-reactstrap-validation';
import { toast } from "../../../../../node_modules/react-toastify";


const FilterModal = ({ filterModal, setFilterModal, updateFiltersData }) => {
    const [location, setLocation] = useState("")



    return (
        <AvForm className='form-horizontal'  >
            <Modal isOpen={filterModal} toggle={() => setFilterModal(!filterModal)}
                className="rightModalSide scrollbar-container mt-0">
                <ModalHeader toggle={() => setFilterModal(!filterModal)}>
                    Resale Filters
            </ModalHeader>
                <ModalBody>
                    <Row>
                        <Col md={12}  >
                            <AvField
                                className="mb-3"
                                name={"location"}
                                label={"Location"}
                                bsSize="lg"
                                value={location}
                                onChange={e => {
                                    const value = e.target.value
                                    setLocation(value)
                                }}
                                required
                                placeholder={'Location'}
                            />
                        </Col>

                    </Row>
                </ModalBody>
                <ModalFooter className="mt-4 px-0 d-flex justify-content-between">
                    <button type='button'
                        className='btn btn-light w-120'
                        onClick={() => {
                            setLocation("")
                            updateFiltersData("")
                        }}>
                        Reset Filter
                     </button>
                    <button
                        type="button"
                        onClick={() => {
                            updateFiltersData(location)
                            setFilterModal(!filterModal)
                        }}
                        className='btn btn-success  w-120'>
                        Apply Filter
                    </button>
                </ModalFooter>
            </Modal>
        </AvForm>
    )
}
export default FilterModal